import { z } from "zod";

export const RequestFieldsRelationInputSchema = z.object({
    requestId: z.string().nullish(),
});

export type RequestFieldsRelationInput = z.infer<typeof RequestFieldsRelationInputSchema>;
